export default __webpack_public_path__ + "static/media/1.07d8f4dc.svg";